import artifact from '$houdini/artifacts/CreateDashboardReport'
import { MutationStore } from '../runtime/stores/mutation'

export class CreateDashboardReportStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
